<template>
  <div class="about-page">
    <!-- 关于公司页面 -->
    <about-us-component></about-us-component>
    
  </div>
</template>

<script>
import AboutUsComponent from '../components/AboutUsComponent.vue'

export default {
  name: 'About',
  components: {
  AboutUsComponent
  }
}
</script>

<style scoped>
.about-page {
  min-height: 100vh;
}
</style>